var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 27,
    viewBox: "0 0 45 27",
    width: 45,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#183acf",
    height: 27,
    rx: 2.344251,
    width: 44.325203
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m16 19 1.9234894-10h3.0765106l-1.9248155 10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30 9.40689072c-.5942664-.1962696-1.5253513-.40689072-2.6881956-.40689072-2.9636875 0-5.0513772 1.3139571-5.06914 3.1971257-.0166948 1.3920493 1.4903879 2.1686157 2.6281057 2.6320218 1.1674536.4748378 1.5599775.7777046 1.5544126 1.2017182-.0074199.6493821-.9323215.946063-1.7944351.946063-1.2005059 0-1.8382799-.1468311-2.8232715-.5085392l-.3865093-.1540068-.4209668 2.1687641c.7005621.2704027 1.996009.5047286 3.3410905.5168532 3.1528387 0 5.1996065-1.2989127 5.222878-3.3098595.0112985-1.1020493-.7878021-1.9407727-2.5182125-2.6321702-1.0483979-.4481637-1.690444-.74722-1.6836425-1.2010254 0-.4026842.5434514-.8332797 1.7176504-.8332797.9808319-.0134113 1.6912873.1748907 2.2448567.3711603l.2688027.1117935z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m36.7459878 9h-2.1518749c-.6666319 0-1.1654706.17818715-1.4582605.82980213l-4.1358524 9.17019787h2.9242974s.4781712-1.2329978.5863104-1.5037033c.3195636 0 3.1603559.0042937 3.566504.0042937.0832963.3502916.338822 1.4994096.338822 1.4994096h2.5840662zm-3.4141593 6.4613033c.2303176-.5765269 1.1095222-2.7971702 1.1095222-2.7971702-.0164401.0266309.2285953-.5793383.3692492-.9550341l.1882519.8627202s.5332324 2.3885564.6446596 2.889433h-2.3116829z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.9971736 9-2.775387 6.8301356-.2957084-1.3880276c-.5166661-1.6001024-2.12643309-3.3336404-3.9260782-4.201535l2.53774718 8.759427 2.99931992-.0033257 4.4629329-9.9966743z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.68340817 9h-4.64663087l-.0367773.191244c3.61503032.76084405 6.0070669 2.5995192 7 4.808756l-1.01037665-4.22398978c-.17443564-.58204288-.68035303-.75572605-1.30621518-.77601022"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.27f46dee2b8b5f36a13a56a80d75c311.svg";
export { ForwardRef as ReactComponent };